import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { NgToastService } from 'ng-angular-popup';
import { StatusBadgeComponent } from "@/app/components/shared/status-badge/status-badge.component";

@Component({
  selector: 'app-rfp-applicant-clarification-addendums',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    StatusBadgeComponent
  ],
  templateUrl: './rfp-applicant-clarification-addendums.component.html',
  styleUrl: './rfp-applicant-clarification-addendums.component.css'
})
export class RfpApplicantClarificationAddendumsComponent implements OnInit {
  @Input() projectId: number;
  @Input() rfpId: number;

  addendums: any;

  constructor(
    private tenderingService: TenderingService,
    private toast: NgToastService,
  ) { }

  ngOnInit(): void {
    this.fetchAddendums();
  }

  fetchAddendums() {
    this.tenderingService.getRFPAddendums(this.projectId, this.rfpId).subscribe({
      next: (response) => {
        if (response?.meta?.success) {
          this.addendums = response.data;
          return
        }
        // this.toast.warning('Error while fetching addendums', 'DANGER', 4000);
      },
      error: (error) => {
        console.error('Error fetching addendums:', error);
        // this.toast.danger('Error while fetching addendums', 'DANGER', 4000);
      },
    });
  }
}
